const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// Read on demand: animations mount only while the widget is open, so a changed setting applies next time
export const getIsMotionReduced = () => !!window.matchMedia?.(REDUCED_MOTION_QUERY).matches;

// Exponential ramp, frame-rate independent; quick attack, slow release like a VU meter
export const getSmoothedLevel = (current, target, frameS, attackS, releaseS) =>
    current + (target - current) * (1 - Math.exp(-frameS / (target > current ? attackS : releaseS)));
